import React, { Component } from 'react';

import $ from 'jquery';
import { withRouter } from 'react-router';

import gemIcon from '../../img/gem.png';

class LadderModal extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      ladder: null,
      gameSlug: ""
    };
    
    this.keyDown = this.keyDown.bind(this);
    this.close = this.close.bind(this);
  };
  
  componentDidMount() {
    document.addEventListener("keydown", this.keyDown, false);
  };
  
  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyDown, false);
  };
  
  keyDown(e) {
    if (e.keyCode === 27) {
      this.close();
    }
  };
  
  close() {
    $("#ladder_modal").fadeOut("fast", function() {
      $("#ladder_modal_overlay").fadeOut("fast", function() {
        document.body.style.overflow = "auto";
      });
    });
  };
  
  getLadderRewardTypeTitle() {
    if (!this.state.ladder || !this.state.ladder.ladderRewardType || !this.state.ladder.ladderRewardMinutes) {
      return ''
    }

    var rewardTypeSlug = 'dailypremios';
    var minutes = '';

    switch (this.state.ladder.ladderRewardType) {
      case 'Daily':
        rewardTypeSlug = 'dailypremios';
        break;

      case 'Hourly':
        rewardTypeSlug = 'hourlypremios';
        break;

      case 'Minutes':
        minutes = this.state.ladder.ladderRewardMinutes;
        rewardTypeSlug = 'minutespremios';
        break;
    }
    
    var defaultTitle = (this.state.ladder.ladderRewardType + " Premios");
    return minutes + ' ' + (this.props.textosShow[rewardTypeSlug] || defaultTitle);
  }

  play() {
    let clase = this;
    if (clase.props.loggedIn) {
      fetch(clase.props.urlGlobal + "api/juego", {
        method: "POST",
        body: JSON.stringify({
          action: "setLadderPlayer",
          lan: clase.props.getLanActual(),
          id: clase.state.ladder.id
        }),
        headers: clase.props.getHeadersToSend()
      }).then(function(response) {
        return response.json();
      }).then(function(result) {
        if (!result.success) {
          alert(result.msg);
        }
        else {
          if (clase.state.ladder.ladderStatus == 0 && result.partida_id != null) {
            window.location = clase.props.urlGlobal + "playGame/" + clase.state.ladder.slug 
                            + "/?gameMode=" + clase.state.ladder.id 
                            + "&partida=" + result.partida_id 
                            + "&game=" + clase.state.gameSlug
                            + "&ladder_player_id=" + result.ladder_player_id
                            + "&ladder_entrada_id=" + result.ladder_entrada_id;
          } else if (clase.state.ladder.ladderStatus == 1) {
            clase.props.history.replace("/ladder/" + clase.state.ladder.id);
          }
          
          clase.close();
        }
      });
    }
    else{
      alert(clase.props.textosShow.paraaccederajugardebeestarregistradoconunacuenta || "Para acceder a jugar debe estar registrado con una cuenta.");
    }
  };

  getLoopReward () {
    if (this.state.ladder.ladderDailyRewards.length > this.state.ladder.ladderFinalRewards.length) {
      return this.state.ladder.ladderDailyRewards;
    } else {
      return this.state.ladder.ladderFinalRewards;
    }
  }

  render() {
    return (
      <div 
        className="modalx-overlay close_mw"
        id="ladder_modal_overlay">
        <div 
          className='modal_window' 
          id="ladder_modal">
          <button 
            id="close_modal" 
            className="link-button close_mw"
            onClick={this.close.bind()}></button>
          <div className='modal_top'>
            <div className='modal_bottom'>
              <div className='modal_content'>
                {
                  this.state.ladder ? (
                    <div>
                      <h5>
                        {/* {this.props.textosShow.dailypremios || "Daily Premios"} */}
                        {this.getLadderRewardTypeTitle()}
                      </h5>
                      <div className='premio'>
                        <img
                          src={gemIcon}
                          />
                        <div>
                          {this.state.ladder.totalLDRs}
                        </div>
                      </div>

                      <h5>
                        {this.props.textosShow.finalpremios || "Final Premios"}
                      </h5>
                      <div className='premio'>
                        <img
                          src={gemIcon}
                          />
                        <div>
                          {this.state.ladder.totalLFRs}
                        </div>
                      </div>
                      
                      <table>
                        <thead>
                          <tr className='subtitle'>
                            <td>
                              <span>#</span>
                            </td>
                            <td style={{padding:0}}>
                              <center>
                                {/* <span>{this.props.textosShow.dailypremios || "Daily Premios"}</span> */}
                                <span>
                                  {this.getLadderRewardTypeTitle()}
                                </span>
                              </center>
                            </td>
                            <td style={{padding:0}}>
                              <center>
                                <span>{this.props.textosShow.finalpremios || "Final Premios"}</span>
                              </center>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          { 
                            this.getLoopReward() && this.getLoopReward().map((item, index) =>
                              <tr key={`item-${item.ind}`}>
                                <td>
                                  <span>
                                    #{item.ind}
                                  </span>
                                </td>
                                <td className='entry_pay'>
                                  <div>
                                    <span>
                                      + {this.state.ladder.ladderDailyRewards[index] ? this.state.ladder.ladderDailyRewards[index].gemas : 0}
                                      <img
                                        src={gemIcon}
                                        />
                                    </span>
                                  </div>
                                </td>
                                <td className='entry_pay'>
                                  <div>
                                    <span>
                                      + {this.state.ladder.ladderFinalRewards[index] ? this.state.ladder.ladderFinalRewards[index].gemas : 0}
                                      <img
                                        src={gemIcon}
                                        />
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )
                          }
                        </tbody>
                      </table>
                      <div className='vs_player'>
                        <h6>
                          Ladder Game
                        </h6>
                      </div>
                      <div className='modal_button'>
                        <button 
                          className='button button_regular'
                          onClick={this.play.bind(this)}
                          >
                          {this.props.textosShow.inscribirse || "Inscribirse"}
                        </button>
                      </div>
                    </div>
                  ) : (
                    null
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
};

export default LadderModal;
